// angles and rotations
export function degreesToRadians(degrees: number) {
  return degrees * (Math.PI / 180);
}

export function radiansToDegrees(radians: number) {
  return (Math.PI * 180) / radians;
}
